import { useDispatch } from "react-redux";
import { Button, Input } from "../../../components/ui";
import {
  setActiveCategoryTab,
  setAddParameterPanelStatus,
} from "../../../reducers/riskEngineSlice";
import CustomDropdown from "../../../components/components-library/dropdown";
import RulesSection from "../add-rule/add-rule";
import useAddParameter from "./useAddParameter";
import { useState } from "react";
import MultiSelectDropdown from "../../../components/components-library/multiSelectDropdown";
import { ArrowForwardIos } from "@mui/icons-material";
import ModalHeader from "../../../components/ui/modal/modal-header";
import ModalFooter from "../../../components/ui/modal/modal-footer";
import Modal from "../../../components/ui/modal";
import deleteicon from "../../../assets/images/delete_icon.svg";
const AddParameter = () => {
  const dispatch = useDispatch();
  const categoryOptions = [
    { value: "FIN", label: "Financial" },
    { value: "TXN", label: "Transaction" },
    { value: "AMID", label: "AMID" },
    { value: "CREDIT", label: "Credit Score" },
  ];
  const {
    onUpdateAddParameterInput,
    onSaveParameterData,
    addParameterRuleData,
    handleRuleChange,
    handleAddRule,
    handleDeleteRule,
    rebalanceRequired,
    setRebalanceRequired,
    getAllParametesRules,
    adjustTargetParams,
    setAdjustTargetParams,
    addEditParameterMode,
    onUpdateParameterData,
    deleteParameterValidationheck,
    deleteParameterModal,
    setDeleteParameterModel,
    deleteParameterFun,
  } = useAddParameter();

  // const [selectedParams, setSelectedParams] = useState<any[]>([]);
  const [selectedParams, setSelectedParams] = useState<any[]>([]);

  const onChangeAdjustWeight = (paramId: number, value: any) => {
    setAdjustTargetParams((prev) =>
      prev.map((p) =>
        p.param_id === paramId ? { ...p, weight: Number(value) } : p
      )
    );
  };
  const handleAdjustRuleChange = (
    paramId: number,
    ruleIndex: number,
    field: string,
    value: any
  ) => {
    setAdjustTargetParams((prev) =>
      prev.map((param) => {
        if (param.param_id !== paramId) return param;

        const updatedRules = [...param.rules];

        updatedRules[ruleIndex] = {
          ...updatedRules[ruleIndex],
          [field]: value,
        };

        return {
          ...param,
          rules: updatedRules,
        };
      })
    );
  };
  const handleAdjustAddRule = (paramId: number) => {
    setAdjustTargetParams((prev) =>
      prev.map((param) => {
        if (param.param_id !== paramId) return param;

        return {
          ...param,
          rules: [
            ...param.rules,
            {
              rule_id: Date.now(),
              rule: "",
              score: "",
              status: 1,
            },
          ],
        };
      })
    );
  };
  const handleAdjustDeleteRule = (paramId: number, ruleIndex: number) => {
    setAdjustTargetParams((prev) =>
      prev.map((param) => {
        if (param.param_id !== paramId) return param;

        const updatedRules = param.rules
          .map((rule: any, i: number) => {
            if (i !== ruleIndex) return rule;

            // If rule exists in DB → mark deleted
            if (rule.rule_id) {
              return { ...rule, status: 0 };
            }

            // If newly added rule → remove
            return null;
          })
          .filter(Boolean);

        return {
          ...param,
          rules: updatedRules,
        };
      })
    );
  };
  const [openParams, setOpenParams] = useState<number[]>([]);
  const toggleParam = (paramId: number) => {
    setOpenParams((prev) =>
      prev.includes(paramId)
        ? prev.filter((id) => id !== paramId)
        : [...prev, paramId]
    );
  };
  return (
    <>
      {" "}
      <div>
        {" "}
        <div
          className="p-4 bg-gray-bg overflow-y-auto"
          style={{
            height: "calc(100vh - 9rem)",
          }}
          id="scroll_style"
        >
          <div>
            <Input
              label="Parameter Name "
              type="text"
              required={true}
              value={addParameterRuleData?.param_name}
              onChange={(e) => {
                onUpdateAddParameterInput("PARAMETERNAME", e.target.value);
              }}
              palceholder="Enter a descriptive name for this risk parameter"
              disabled={addEditParameterMode === "DELETE"}
            />
            <div className="space_18 flex items-center gap-2">
              <Input
                label="Weight "
                type="number"
                required={true}
                value={
                  addParameterRuleData?.weight !== 0
                    ? addParameterRuleData?.weight
                    : ""
                }
                onChange={(e) => {
                  const value = e.target.value;
                  const updatedVal = value.replace(/\D/g, "");
                  onUpdateAddParameterInput("WEIGHT", updatedVal);
                }}
                palceholder="(1-100)"
                className="flex-1"
                onFocus={(e) => {
                  e.target.value === "0" &&
                    onUpdateAddParameterInput("WEIGHT", "");
                }}
                disabled={addEditParameterMode === "DELETE"}
              />
              <CustomDropdown
                label="Category"
                options={categoryOptions}
                value={addParameterRuleData?.type}
                onChange={(value: any) => {
                  onUpdateAddParameterInput("PARAMETERTYPE", value);
                  dispatch(setActiveCategoryTab(value));
                }}
                placeholder=""
                className="flex-1"
                required={true}
                disabled={addEditParameterMode !== "ADD"}
              />
            </div>

            <div className="space_18">
              <Input
                label="Description"
                type="text"
                required={false}
                value={addParameterRuleData?.desc}
                onChange={(e) => {
                  onUpdateAddParameterInput("DESCRIPTION", e.target.value);
                }}
                palceholder="Enter description here..."
                disabled={addEditParameterMode === "DELETE"}
              />
            </div>
          </div>
          {addEditParameterMode !== "DELETE" && (
            <div className="space_18">
              <RulesSection
                rules={addParameterRuleData.rules}
                handleRuleChange={handleRuleChange}
                handleAddRule={handleAddRule}
                handleDeleteRule={handleDeleteRule}
              />
            </div>
          )}
          {rebalanceRequired && (
            <>
              <div className="mt-4">
                <span className="color-sub-text fs-14">
                  To Add new / Edit / Delete parameter, you have to modify the
                  weight in existing parameter. Please proceed to select the
                  parameter you want to modify.
                </span>
              </div>
              <div className="space_18">
                <MultiSelectDropdown
                  label="Select Parameters "
                  required
                  options={getAllParametesRules
                    .filter((p) => p.param_id != addParameterRuleData.param_id)
                    .map((p) => ({
                      value: p.param_id,
                      label: `${p.param_name} (${p.weight})`,
                    }))}
                  value={selectedParams}
                  onChange={(values: number[]) => {
                    setSelectedParams(values);

                    const selectedParamsList = getAllParametesRules.filter(
                      (p) => values.includes(p.param_id)
                    );

                    setAdjustTargetParams(
                      selectedParamsList.map((param) => ({
                        param_id: param.param_id,
                        param_name: param.param_name,
                        weight: param.weight,
                        rules: param.rules || [],
                        type: param.type,
                        status: param.status,
                      }))
                    );
                  }}
                />

                {adjustTargetParams.length > 0 && (
                  <div className="space_18 flex flex-col gap-2">
                    {adjustTargetParams.map((param: any) => {
                      const isOpen = openParams.includes(param.param_id);

                      return (
                        <div key={param.param_id} className="border br-10 ">
                          <div
                            className="flex justify-between items-center bg-oceangreen px-2 py-2 cursor-pointer"
                            style={{
                              borderRadius: isOpen
                                ? "10px 10px 0px 0px"
                                : "10px",
                            }}
                            onClick={() => toggleParam(param.param_id)}
                          >
                            <div className="flex items-center gap-2">
                              <div
                                style={{
                                  transition: "transform 0.3s ease",
                                  transform: isOpen
                                    ? "rotate(90deg)"
                                    : "rotate(0deg)",
                                }}
                              >
                                <ArrowForwardIos style={{ fontSize: 16 }} />
                              </div>

                              <h4 className="font-semibold fs-14">
                                {param.param_name}
                              </h4>
                            </div>

                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                setAdjustTargetParams((prev) =>
                                  prev.filter(
                                    (p) => p.param_id !== param.param_id
                                  )
                                );
                                setSelectedParams((prev) =>
                                  prev.filter((id) => id !== param.param_id)
                                );
                              }}
                              className="bg-primary text-white p-2 rounded-[30px] fs-12"
                              style={{ padding: "4px 10px" }}
                            >
                              Remove
                            </div>
                          </div>

                          {/* Collapsible Content */}
                          {isOpen && (
                            <div className="p-4 bg-white">
                              <Input
                                label="Weight"
                                type="number"
                                required
                                value={param.weight !== 0 ? param.weight : ""}
                                onChange={(e) => {
                                  const value = e.target.value;

                                  const updatedVal = value.replace(/\D/g, "");

                                  onChangeAdjustWeight(
                                    param.param_id,
                                    updatedVal === "" ? "" : Number(updatedVal)
                                  );
                                }}
                                onFocus={(e) => {
                                  e.target.value === "0" &&
                                    onChangeAdjustWeight(param.param_id, "");
                                }}
                              />

                              <div className="space_18">
                                <RulesSection
                                  fromMainAction
                                  rules={param.rules}
                                  handleRuleChange={(ruleIndex, field, value) =>
                                    handleAdjustRuleChange(
                                      param.param_id,
                                      ruleIndex,
                                      field,
                                      value
                                    )
                                  }
                                  handleAddRule={() =>
                                    handleAdjustAddRule(param.param_id)
                                  }
                                  handleDeleteRule={(ruleIndex) =>
                                    handleAdjustDeleteRule(
                                      param.param_id,
                                      ruleIndex
                                    )
                                  }
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        <div className="flex justify-between mt-4 px-2">
          <Button
            variant="transparent"
            onClick={() => {
              dispatch(setAddParameterPanelStatus(false));
            }}
          >
            Cancel
          </Button>

          <div className="flex gap-2">
            <Button
              className=""
              onClick={() => {
                if (addEditParameterMode == "EDIT") {
                  onUpdateParameterData();
                } else if (addEditParameterMode == "DELETE") {
                  deleteParameterValidationheck();
                } else {
                  onSaveParameterData();
                }
              }}
              variant={
                addEditParameterMode == "DELETE" ? "danger" : "contained"
              }
            >
              {addEditParameterMode == "DELETE"
                ? "Delete Parameter"
                : "Save Parameter"}
            </Button>
          </div>
        </div>
      </div>
      {deleteParameterModal && (
        <Modal
          open={deleteParameterModal}
          onClose={() => {
            setDeleteParameterModel(false);
          }}
          width={"35vw"}
        >
          <>
            <ModalHeader title={"Confirm Deletion"} content={<></>} />
            <div className="p-6 flex flex-col text-center fs-14 gap-4">
              <div className="flex justify-center">
                <img src={deleteicon} />
              </div>
              <div className="flex flex-col">
                <span>Are you sure you want to delete this parameter?</span>
                <span>
                  All associated rules will also be deleted. This action cannot
                  be undone.
                </span>
              </div>
            </div>
            <ModalFooter>
              <Button
                className="w-26"
                variant="gray"
                data-shape="round"
                onClick={() => {
                  setDeleteParameterModel(false);
                }}
              >
                Cancel
              </Button>
              <Button
                className="w-26"
                variant="danger"
                data-shape="round"
                onClick={() => {
                  deleteParameterFun();
                }}
              >
                Delete
              </Button>
            </ModalFooter>
          </>
        </Modal>
      )}
    </>
  );
};
export default AddParameter;
